import {
  Box,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  HStack,
  Text,
  Spacer,
} from "@chakra-ui/react";
import { ArrowRightIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { scroller } from "react-scroll";

type NavItem = {
  title: string;
  nav: string;
};
type ContentMenuProps = {
  items: NavItem[];
};

export default function ContentMenu({ items }: ContentMenuProps) {
  const handleScrollClick = (sectionId: string) => {
    scroller.scrollTo(sectionId, {
      duration: 1000,
      smooth: true,
    });
  };
  return (
    <Box
      position="fixed"
      top={window.innerHeight / 2}
      left={0}
      zIndex={10}
      mt={["4", "4"]}
      ml={["0", "4"]}
      p="1.5"
      color="#000"
      borderRadius={30}
      backgroundColor="#fff"
      boxShadow={"inset 2px 2px 6px #bebebe, inset -2px -2px 6px #ffffff"}
    >
      <Menu placement="right">
        <MenuButton
          as={IconButton}
          icon={<ArrowRightIcon />}
          borderRadius={30}
          sx={{ bg: "transparent", _active: { bg: "transparent" } }}
          _hover={{ bg: "transparent", _active: { bg: "transparent" } }}
        />
        {/* 
          The above 2 lines of code (sx and _hover) are to prevent a default blue-grey background that the Chakra UI menu has.
          that spans multiple lines.The sx prop in Chakra UI is a powerful tool that allows you to apply any valid CSS to 
          an element while also utilizing tokens from your theme.
          */}
        <MenuList
          backgroundColor="#fff"
          boxShadow={"inset 2px 2px 6px #bebebe, inset -2px -2px 6px #ffffff"}
          borderRadius={30}
          padding={8}
        >
          {items.map((item: NavItem, index: number) => (
            <MenuItem
              mb={2}
              key={index}
              onClick={() => handleScrollClick(item.nav)}
              fontSize={"lg"}
              borderRadius={30}
              pl={5}
              // The sx line is to prevent a default blue-grey background that the Chakra UI menu has
              sx={{ bg: "transparent", _active: { bg: "transparent" } }}
              _hover={{
                bg: "black",
                color: "white",
              }}
            >
              <HStack w="100%">
                <Text>{item.title}</Text> <Spacer />
                <Icon w={5} h={5} as={ChevronRightIcon} />
              </HStack>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
}
